import { render, staticRenderFns } from "./ReedirectButton.vue?vue&type=template&id=1e111340&"
import script from "./ReedirectButton.vue?vue&type=script&lang=js&"
export * from "./ReedirectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports